module.exports = __webpack_public_path__ + "static/media/sz.3fd422e9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sz.svg
// module id = 1361
// module chunks = 0